import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { ConfigService } from '@rxap/config';
import { isUploadEnabled } from '../is-upload-enabled';
import { logGuardResult } from './guard-logger';

/**
 * Blocks direct navigation to `/upload` when `iiRDS.upload` is disabled.
 * Redirecting to `/iirds` re-enters configGuard, which resolves the same
 * "no upload, no fixed source" state it would if upload had never been
 * offered (typically `/not-found`).
 */
export const uploadEnabledGuard: CanActivateFn = () => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  if (isUploadEnabled(configService)) {
    return logGuardResult('uploadEnabledGuard', true, {
      reason: 'upload enabled',
    });
  }

  return logGuardResult(
    'uploadEnabledGuard',
    new RedirectCommand(router.parseUrl('/iirds')),
    { reason: 'upload disabled' }
  );
};
